import { NgModule } from '@angular/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { UserSettingsPanelComponent } from './user-settings.component';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'app/main/material.module';
import { DialogHeaderModule } from 'app/components/dialogs/dialog-header/dialog-header.module';

@NgModule({
    declarations: [
        UserSettingsPanelComponent
    ],
    imports     : [
        MaterialModule,
        TranslateModule,
        FuseSharedModule,
        DialogHeaderModule,
    ],
    exports: [
        UserSettingsPanelComponent
    ]
})
export class UserSettingsPanelModule
{
}
